import Api from "./Api";

export default class AuthServices {

  static signIn = (email: string, password: string) => {
      return Api.post(`login/`, {email, password,});
}
}
